<template>
    <div class="layout__padding-clear">
        <div class="layout__position__relative">
            <div class="grad"></div>
            <img class="layout__padding-clear layout__width-100"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/LHN_Crop_2000x750.jpg">
            <div class="layout__padding-clear">
                <div class="component__banner-title layout__padding-clear">Land & New Homes
                    <div class="text__size-20 text__line-height-30px layout__padding-20-0">
                        <div class="layout__padding-clear layout__width-50">
                            Essential services - all from one point of contact
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="layout__width-70 layout__padding-clear">

            <div class="text__size-36 text__colour-teal layout__width-100 text__align-center text__style-bold-900 text__line-height-2 layout__padding__top-20px">
                Create the WOW factor
            </div>
            <hr>

            <p class="text__line-height-30px text__align-center">If you’re involved in planning, designing, building or
                selling new build properties, Ravensworth’s essential
                marketing services support will provide a wrap around service from start to finish – all available from
                one
                point of contact. Whether you’re looking to help clients bring their development to life with stunning
                CGIs,
                promote developments with a bespoke microsite or increase awareness with the highest quality marketing,
                Ravensworth has more than 125 years of combined experience to put at your disposal.</p>

            <hr>

            <div class="layout__padding-20-0 text__align-center">
                <el-button class="layout__width-200px button-red"
                           v-on:click="contactUs()">Get a quote today
                </el-button>
            </div>


        </div>
        <div>



            <div class="layout__padding-clear layout__width-70">
                <div class="text__size-30 text__align-center text__colour-teal text__style-bold-900 layout__padding-20px">Our work</div>
                <div class="">
                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-2.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-3.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-4.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-5.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-6.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-7.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-8.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-9.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-10.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-11.jpg" class="layout__width-100 zoom">
                    </div>

                    <div class="component__product-3">
                        <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/CGI-shots-1400x1000-12.jpg" class="layout__width-100 zoom">
                    </div>
                </div>
            </div>


        </div>

        <!--<div class="">-->
            <!--<el-image-->
                    <!--style="width: 100px; height: 100px"-->
                    <!--:src="url"-->
                    <!--:preview-src-list="url"-->
                    <!--:previewSrcList="true">-->
            <!--</el-image>-->
        <!--</div>-->


        <el-dialog
                :visible.sync="showPreview"
                :close-on-press-escape="true"
                :close-on-click-modal="true"
                :show-close="true"
                width="80%"
                top="5vh"
                style="border-radius: 0px"
        class="colour__background-transparent">
            <div class="colour__background-transparent" v-show="showPreview">
                <!--<iframe src="https://ravensworth.co.uk/wp-content/uploads/2018/09/Ravensworth-Autumn-DM-Collection.pdf" class="layout__width-100"></iframe>-->
                <embed src="https://ravensworth.co.uk/wp-content/uploads/2018/09/Ravensworth-Autumn-DM-Collection.pdf" class="layout__width-100" style="height:80vh;">
            </div>
        </el-dialog>

        <!--<embed src="https://ravensworth.co.uk/wp-content/uploads/2018/09/Ravensworth-Autumn-DM-Collection.pdf" class="layout__width-100" style="height:100vh;">-->

        <!--<div class="component__dialog layout__overflow-hidden" v-show="showPreview">-->
            <!--&lt;!&ndash;<div class="layout__padding-clear layout__opacity-1">&ndash;&gt;-->
                <!--&lt;!&ndash;<embed src="https://ravensworth.co.uk/wp-content/uploads/2018/09/Ravensworth-Autumn-DM-Collection.pdf" class="layout__width-100" style="height:80vh;">&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--</div>-->


        <!--<div class="component__dialog-body layout__overflow-hidden" v-show="showPreview">-->
            <!--<embed src="https://ravensworth.co.uk/wp-content/uploads/2018/09/Ravensworth-Autumn-DM-Collection.pdf" class="layout__width-100" style="height:80vh;">-->
        <!--</div>-->


    </div>

</template>

<script>
    import Router from '../../router';

    export default {
        name: "landnewhomes",
        props: {},
        components: {},
        mixins: [],
        data() {
            return {
                showPreview: false,
                rifat: 'https://rpsassets.blob.core.windows.net/rpsimages/images/cgi/SITE_PROOF_7_0004.jpg'
            }
        },
        created() {
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            }
        },
    };
</script>